import { useCallback } from "react";
import { useSelector } from "react-redux";
import { useLanguagePersistence } from "./useLanguagePersistence";
import { RootState } from "../../../../app/store";

/**
 * Main hook for language functionality
 */
export function useLanguage() {
  const { currentLanguage, supportedLanguages, languageNames } = useSelector(
    (state: RootState) => state.language
  );

  // Use the persistence hook
  const { saveLanguagePreference } = useLanguagePersistence();

  // Function to switch language - simplified without options
  const switchLanguage = useCallback(
    (lang: string) => {
      if (!supportedLanguages.includes(lang) || lang === currentLanguage) {
        return; // Don't switch to unsupported languages or current language
      }

      // Always save to cookie
      saveLanguagePreference(lang);

      // Always reload the page to apply the new language
      window.location.reload();
    },
    [currentLanguage, supportedLanguages, saveLanguagePreference]
  );

  return {
    currentLanguage,
    supportedLanguages,
    languageNames,
    switchLanguage,
  };
}
